import React from "react";
import axios from "axios";
import { useState } from "react";
import { Navigate, useNavigate ,useParams} from "react-router-dom";
import { appendFile } from "fs";
const SERVER = `https://volunteer-server.onrender.com`
//const SERVER = `http://localhost:8800`
const Likes = ({ getLikes, threadId ,category}) => {    

    const [numberOfLikes,setLikes] = useState("")
    const navigate = useNavigate();
    const { id } = useParams();
    const getLike = async()=>{
        const res = await getLikes(threadId)
        setLikes(res)
    }
    getLike()
    const handleLikeFunction = async()=>{
        if(JSON.parse(localStorage.getItem("user")).ID_user){
        if(category=='forum'){

        try{
           const res =  await axios.post(`${SERVER}/api/thread/like`, {
                forumId:threadId,
                user_id: JSON.parse(localStorage.getItem("user")).ID_user,
            });
            alert(res.data.message)
            navigate('/forum')
        }catch(e){
           console.log(e)
           alert(e.response.data.error_message)
        }
    }else{
        try{
            const res =  await axios.post(`${SERVER}/api/thread/replylike`, {
                 forumId:threadId,
                 user_id: JSON.parse(localStorage.getItem("user")).ID_user,
             });
             alert(res.data.message)
             navigate(`/${id}/replies`)
         }catch(e){
            console.log(e)
            alert(e.response.data.error_message)
         }

    }
}else{
    alert('You must be logged in')
}
    }
    // const handleLikeFunction = () => {
    //     fetch("http://localhost:8800/api/thread/like", {
    //         method: "POST",
    //         body: JSON.stringify({
    //             threadId,
    //             userId: JSON.parse(localStorage.getItem("user")).ID_user,
    //         }),
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //     })
    //         .then((res) => res.json())
    //         .then((data) => {
    //             if (data.error_message) {
    //                 alert(data.error_message);
    //             } else {
    //                 alert(data.likes);
    //             }
    //         })
    //         .catch((err) => console.error(err));
    // };
    return (
        <div className='likes__container'>
            {category=='replies' ? 
            <>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 24 24'
                fill='currentColor'
                className='w-4 h-4 likesBtn'
                onClick={handleLikeFunction}
            >
                <path d='M7.493 18.75c-.425 0-.82-.236-.975-.632A7.48 7.48 0 016 15.375c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75 2.25 2.25 0 012.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23h-.777zM2.331 10.977a11.969 11.969 0 00-.831 4.398 12 12 0 00.52 3.507c.26.85 1.084 1.368 1.973 1.368H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 01-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227z' />
            </svg>
            </> : <>
            <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor'
                className='w-4 h-4 likesBtn'
                onClick={handleLikeFunction}
                 width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.781 2.375c-.381-.475-1.181-.475-1.562 0l-8 10A1.001 1.001 0 0 0 4 14h4v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7h4a1.001 1.001 0 0 0 .781-1.625l-8-10zM15 12h-1v8h-4v-8H6.081L12 4.601L17.919 12H15z"/></svg>
            </>}
           
          
            <p style={{ color: "#434242" }}>
                {numberOfLikes === 0 ? "" : numberOfLikes}
            </p>
        </div>
    );
};

export default Likes;